import moment from 'moment';
import { setFilters, setFiltersAction } from './actions';
import immerHandleActions from 'redux/utils/immerHandleActions';

const init: types.redux.numbers.State = {
	filters: {
		service: [],
		userType: [],
		department: [],
		myBills: {
			organization: '',
			billingId: '',
			billingPeriod: { startDate: moment(new Date()), endDate: moment().endOf('day'), period: '' },
			billingStatus: {
				value: 'all',
				id: '1',
				name: 'All',
			},
		},
	},
};

const reducers = {
	[setFilters]: (state: types.redux.numbers.State, { payload }: setFiltersAction) => ({
		filters: {
			...state.filters,
			[payload.type]: payload.value,
		},
	}),
};

export default immerHandleActions(reducers, init);
